import React from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import { CancelToken } from 'axios';
import CreatableSelect from 'react-select/creatable';

import api from '../../apiSingleton';
import { LOCATION_HOUSE, LOCATION_STREET, LOCATION_LOCALITY, LOCATION_CUSTOM } from '../../consts';

class AutocompleteLocation extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      items: [],
      isLoading: false,
    };

    this.requestTimer = null;
    this.source = null;

    this.updateFilter = this.updateFilter.bind(this);
    this.handlerOnSelect = this.handlerOnSelect.bind(this);
    this.handlerOnChange = this.handlerOnChange.bind(this);
    this.filterOption = this.filterOption.bind(this);
    this.unique = this.unique.bind(this);
    this.handlerFullTextSearch = this.handlerFullTextSearch.bind(this);
  }

  prepareItems (items, searchText) {
    return items.map(location => {
      const { house, street, locality, regionDistrict, region } = location;

      if (house) {
        return {
          id: house.id,
          type: LOCATION_HOUSE,
          name: `${house.fullName} (${locality.name})`,
          shortName: `${street.name}, ${house.name}`,
          streetId: street.id,
          localityId: locality.id,
          label: `${house.fullName} (${locality.name})`,
          value: house.id,
          searchText,
          kind: 'house',
          created: false
        };
      }

      if (street) {
        return {
          id: street.id,
          type: LOCATION_STREET,
          name: `${street.fullName} (${locality.name})`,
          shortName: street.name,
          localityId: locality.id,
          label: `${street.fullName} (${locality.name})`,
          value: street.id,
          searchText,
          kind: 'street',
          created: false
        };
      }

      if (locality) {
        const nameLocality = locality.fullName + (
            regionDistrict ? ` (${regionDistrict.fullName})` : (region ? ` (${region.fullName})` : '')
        );
        return {
          id: locality.id,
          type: LOCATION_LOCALITY,
          name: nameLocality,
          shortName: locality.name,
          label: nameLocality,
          value: locality.id,
          localityId: null,
          searchText,
          kind: 'locality',
          created: false
        };
      }
    });
  }

  unique (list) {
    return [...new Set(list)];
  }

  handlerOnSelect (selectedOptions, action) {
    let selectedOptionsOnly = selectedOptions && selectedOptions.filter(address => !address.created);
    this.setState({
      items: []
    });

    this.updateFilter(selectedOptionsOnly);
  }

  handlerOnChange (value) {
    if (value.length < 1) {
      this.setState({ items: [] })
      return value;
    }

    this.source && this.source.cancel('user typing...');
    clearTimeout(this.requestTimer);
    this.setState({isLoading: true});
    this.requestTimer = setTimeout(() => {
      this.source = CancelToken.source();
      api.gis
        .address(value, 55, 1, this.source)
        .then(data => {
          this.setState({
            items: this.prepareItems(data, value),
            isLoading: false
          });
        }).catch(function (thrown) {
          console.warn('Request canceled: ', thrown.message);
        });
    }, 300);
  }

  filterOption (option, inputValue) {
    const { label, data } = option;
    return label.includes(inputValue) || data.searchText.includes(inputValue);
  };

  updateFilter (items) {
    let filter = {
      houseId: null,
      streetId: null,
      localityId: null,
      address: null,
    };
    let houseIdArr = [];
    let streetIdArr = [];
    let localityIdArr = [];
    if (items !== null) {
      for (const item of items) {
        switch (item.type) {
          case LOCATION_HOUSE:
            houseIdArr.push(item.id);
            streetIdArr.push(item.streetId);
            localityIdArr.push(item.localityId);
            continue;
          case LOCATION_STREET:
            streetIdArr.push(item.id);
            localityIdArr.push(item.localityId);
            continue;
          case LOCATION_LOCALITY:
            localityIdArr.push(item.id);
            continue;
        }
      }
      filter.houseId = this.unique(houseIdArr).join(',') || null;
      filter.streetId = this.unique(streetIdArr).join(',') || null;
      filter.localityId = this.unique(localityIdArr).join(',') || null;
    }
    this.props.updateAutocompleteOptions(items !== null ? fromJS(items) : []);
    this.props.onUpdate(filter);
  }

  handlerFullTextSearch (inputValue) {
    let filter = {
      houseId: null,
      streetId: null,
      localityId: null,
      address: inputValue,
    };
    this.props.updateAutocompleteOptions([{label: inputValue, value: inputValue, created: true}]);
    this.props.onUpdate(filter);
  }

  render () {
    const { items, isLoading } = this.state;
    const { selectedOptions } = this.props;
    return (
      <div className='autocomplete-location-control-box'>
        <CreatableSelect
          onChange={this.handlerOnSelect}
          onCreateOption={this.handlerFullTextSearch}
          options={items}
          value={selectedOptions}
          onInputChange={this.handlerOnChange}
          filterOption={this.filterOption}
          isMulti
          isLoading={isLoading}
          formatCreateLabel={(inputValue)=>`Свободный поиск: ${inputValue}`}
          placeholder='Населенный пункт, улица, дом'
          classNamePrefix='react-select'
          className='react-select-container'
          noOptionsMessage={() => 'Начните вводить или выберите объект в выпадающем списке'}
          loadingMessage={() => 'Поиск...'}
          instanceId='search-input'
          components={{
            IndicatorSeparator: () => null,
            dropdownIndicator: () => null
          }}
        />
      </div>
    );
  }
}

AutocompleteLocation.propTypes = {
  isMapView: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array,
  updateAutocompleteOptions: PropTypes.func.isRequired,
};

AutocompleteLocation.defaultProps = {
  isMapView: false,
  value: null,
  selectedOptions: [],
};

export default AutocompleteLocation;



// WEBPACK FOOTER //
// ./src/ui/Controls/AutocompleteLocation.jsx